import { ref } from 'vue';

function isFormDataPayload(data) {
  return typeof FormData !== 'undefined' && data instanceof FormData;
}

export function useMazdaWriteScope(mazdaPost, writeEndpoints) {
  const localOnly = ref(false);
  const endpointSet = new Set(writeEndpoints || []);

  const scopedMazdaPost = (endpoint, data = {}, config = {}) => {
    if (!localOnly.value || !endpointSet.has(endpoint)) {
      return mazdaPost(endpoint, data, config);
    }

    let requestData = data;
    if (isFormDataPayload(requestData)) {
      if (typeof requestData.has !== 'function' || !requestData.has('localOnly')) {
        requestData.append('localOnly', '1');
      }
    } else {
      requestData = {
        ...(requestData && typeof requestData === 'object' ? requestData : {}),
        localOnly: true,
      };
    }

    return mazdaPost(endpoint, requestData, {
      ...config,
      params: {
        ...(config.params || {}),
        localOnly: '1',
      },
    });
  };

  return { localOnly, scopedMazdaPost };
}
